import React from 'react';

import Modal from '../../Modal';
import { CheckItem, CheckItems } from '../../reusable/CheckItems';
import Text, { TextColor, TextKind } from '../../reusable/Text';

const allowedInfo = [
  'Specific information related to their personal "why" and goals (short/long term)',
  'Interests and hobbies relevant to motivation or coachable goals',
  'Type of work that they do for their company (e.g., desk vs. field role)',
  'Where they are located',
  'Info helpful to staying engaged (e.g., kids/pets but avoid actual names)',
  'Barriers that have held them back in the past',
  'Limitations (e.g., I have ankle pain)',
  'Health/medication info (do not ask; if volunteered, record only if relevant)',
  'Training Info - days per week, facility, types of workout, current status',
  'Our coaching recommendations to the member',
];

type Props = { isOpen: boolean; onClose: () => void };

const InfoModal: React.FC<Props> = ({ isOpen, onClose }: Props) => (
  <Modal isOpen={isOpen} onClose={onClose} testId="notes-guideline-modal">
    <Modal.Header onClose={onClose} closeLabel="Close guidelines">
      <Text kind={TextKind.TitleM} component="h4">
        Guidelines
      </Text>
      <Text kind={TextKind.BodyM} component="h5" color={TextColor.Secondary}>
        Best practices for taking notes
      </Text>
    </Modal.Header>
    <Modal.Content>
      <CheckItems>
        {allowedInfo.map((info) => (
          <CheckItem key={info} text={info} />
        ))}
      </CheckItems>
      <Text kind={TextKind.BodyS} testId="notes-guideline-main-text">
        You are not required to solicit this information and members are not
        required to provide it. It is best discovered through casual
        conversation and discussion of goals. All notes should be relevant and
        professional, avoiding judgmental or inflammatory notes. Exos treats
        notes as confidential to the member, but in limited circumstances such
        as a litigation they may not be kept private. Privacy laws also allow
        members to request a copy of all data Exos holds about them, so members
        have access to their coach notes upon request.
      </Text>
      <Text kind={TextKind.BodyS} testId="notes-guideline-important-text">
        <strong>IMPORTANT NOTE:</strong> Coach notes should never be used to
        hold payment or other financial information, passwords or anything else
        that would be considered sensitive.
      </Text>
    </Modal.Content>
    <Modal.Actions confirmButton={{ label: 'Done', onClick: onClose }} />
  </Modal>
);

export default InfoModal;
